import { Slide } from "react-reveal";
import interior from "../../assets/images/content-icons/interior.png";
import exterior from "../../assets/images/content-icons/exterior.png";
import commercial from "../../assets/images/content-icons/commercial.png";

const HomeServices = () => {
  return (
    <section className="home-services farm-bg section-spacing-80">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head width-600">
              <Slide top>
                <h2 className="section-title">
                  <span className="flexi-green">Our</span> Services
                </h2>
              </Slide>
              <p className="section-subtitle">
                Comprehensive painting solutions in Kampala and Uganda for
                homes, businesses and institutions, delivered with precision,
                reliability and lasting quality.
              </p>
            </div>
            <div className="section-body section-spacing-50">
              <ul className="services-cards-container">
                <li className="service-card interior">
                  <div className="service-icon-container">
                    <img src={interior} alt="Interior Painting Icon" />
                  </div>
                  <h3 className="service-title">Interior Painting</h3>
                  <p className="boldTitle service-title-desc">
                    Transform your property's indoor spaces
                  </p>
                  <p className="service-subtitle">
                    Enhance the beauty and comfort of your home, office, hotel,
                    or apartment with clean, precise, and long-lasting interior
                    painting solutions.
                  </p>
                  <p className="service-includes-title boldTitle">
                    Specializing In:
                  </p>
                  <ul className="service-includes-container">
                    <li>
                      <span className="flexi-gold">✔︎ </span>Walls & Ceilings
                    </li>
                    <li>
                      <span className="flexi-gold">✔︎ </span>Decorative Finishes
                    </li>
                    <li>
                      <span className="flexi-gold">✔︎ </span>Feature Walls
                    </li>
                    <li>
                      <span className="flexi-gold">✔︎ </span>Surface Preparation
                    </li>
                    <li>
                      <span className="flexi-gold">✔︎ </span>Repainting Services
                    </li>
                  </ul>
                  <div className="service-card-cta-container">
                    <a href="/services" className="service-card-sub-cta">
                      View Details &rarr;
                    </a>
                    <a
                      href="https://form.jotform.com/flexipainters/book-site-visit"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="service-card-main-cta button"
                    >
                      Book Site Visit
                    </a>
                  </div>
                </li>
                <li className="service-card exterior">
                  <div className="service-icon-container">
                    <img src={exterior} alt="Exterior Painting Icon" />
                  </div>
                  <h3 className="service-title">Exterior Painting</h3>
                  <p className="boldTitle service-title-desc">
                    Protect and beautify your property's exterior
                  </p>
                  <p className="service-subtitle">
                    Give your property a fresh, durable, and weather-resistant
                    finish that improves appearance while protecting surfaces
                    from the elements.
                  </p>
                  <p className="service-includes-title boldTitle">
                    Specializing In:
                  </p>
                  <ul className="service-includes-container">
                    <li>
                      <span className="flexi-magenta">✔︎ </span>Residential
                      Painting
                    </li>
                    <li>
                      <span className="flexi-magenta">✔︎ </span>Roof Painting
                    </li>
                    <li>
                      <span className="flexi-magenta">✔︎ </span>Waterproofing
                    </li>
                    <li>
                      <span className="flexi-magenta">✔︎ </span>Wall Restoration
                    </li>
                    <li>
                      <span className="flexi-magenta">✔︎ </span>Surface
                      Preparation
                    </li>
                  </ul>
                  <div className="service-card-cta-container">
                    <a href="/services" className="service-card-sub-cta">
                      View Details &rarr;
                    </a>
                    <a
                      href="https://form.jotform.com/flexipainters/book-site-visit"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="service-card-main-cta button"
                    >
                      Book Site Visit
                    </a>
                  </div>
                </li>
                <li className="service-card commercial">
                  <div className="service-icon-container">
                    <img src={commercial} alt="Commercial Painting Icon" />
                  </div>
                  <h3 className="service-title">Commercial Painting</h3>
                  <p className="boldTitle service-title-desc">
                    Professional finishes for business spaces
                  </p>
                  <p className="service-subtitle">
                    High-quality painting solutions for commercial properties,
                    helping businesses maintain professional and attractive
                    environments.
                  </p>
                  <p className="service-includes-title boldTitle">
                    Specializing In:
                  </p>
                  <ul className="service-includes-container">
                    <li>
                      <span className="flexi-skyblue">✔︎ </span>Offices
                    </li>
                    <li>
                      <span className="flexi-skyblue">✔︎ </span>Factories
                    </li>
                    <li>
                      <span className="flexi-skyblue">✔︎ </span>Hotels
                    </li>
                    <li>
                      <span className="flexi-skyblue">✔︎ </span>Schools
                    </li>
                    <li>
                      <span className="flexi-skyblue">✔︎ </span>Commercial
                      Buildings
                    </li>
                  </ul>
                  <div className="service-card-cta-container">
                    <a href="/services" className="service-card-sub-cta">
                      View Details &rarr;
                    </a>
                    <a
                      href="https://form.jotform.com/flexipainters/book-site-visit"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="service-card-main-cta button"
                    >
                      Book Site Visit
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeServices;
